import React from "react";
import { Header } from "../Header";
import { Footer } from "../Footer";
import line from "../../assests/Group 1870 line2.png";
import { Link } from "react-router-dom";
import { useEffect } from "react";

function Press() {
  useEffect(() => {
    // Set the scroll position when the component mounts
    window.scrollTo(0, 0); // Adjust the '500' value as needed
  }, []);
  return (
    <>
      <Header />
      <section className="pressbanner">

      </section>

      <section className="mb-4" style={{ minHeight: '80vh' }}>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12 text-center">
              <h4 class="text-center text-dark fw-bold mt-5 mb-0">
                PRESS RELEASES
              </h4>
              <img className=" img-fluid" src={line} />
            </div>
          </div>
          <div className="row d-flex justify-content-center mt-5">
            <div className="col-md-12 ">
            <h5 class="text-danger  fw-bold">
                <a
                  className="text-decoration-none text-danger"
                  href="https://www.local3news.com/local-news/conditions-in-kenya-impact-chattanooga-nonprofits-mission/article_5e84e554-0736-11ef-8674-83b92ba2949d.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                1. Conditions in Kenya impact Chattanooga nonprofit's mission May 2, 2024                 </a>
              </h5>

              <h5 class="text-danger  fw-bold mt-4">
                <a
                  className="text-decoration-none text-danger"
                  href="https://www.local3news.com/local-news/love-without-reason-celebrates-16-years-of-free-craniofacial-surgeries/article_2a02f0e2-993a-11ee-bc70-9fba6ab7d455.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  2.
                  Love Without Reason marks 16 years of offering free craniofacial surgeries  December 13, 2023
                </a>
              </h5>

              <Link to="/Press5k" className="text-decoration-none">
                <h5 class="text-danger fw-bold mt-4 ">
                  3. 5KRUN4LOVE  September 5, 2023
                </h5>
              </Link>

              <Link to="/Press2" className="text-decoration-none">
                <h5 class="text-danger fw-bold mt-4">
                  4.
                  Love Without Reason announces the appointment of Christy Mathew as the chairwoman of the board June 2020
                </h5>
              </Link>

              <h5 class="text-danger mt-4 fw-bold">
                <a
                  className="text-decoration-none text-danger"
                  href="http://www.wrcbtv.com/story/35608025/eye-on-health-love-without-reason"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  5.
                  Eye on health with Latrice Curry, WRCBTV news channel3  December 2, 2021 
                </a>
              </h5>


              <h5 class="text-danger mt-4 fw-bold">
                <a className="text-danger text-decoration-none" href="https://wdef.com/2017/05/29/love-without-reason-helping-less-fortunate/" target="_blank" rel="noopener noreferrer">6. WDEF News Channel 12 May 29, 2017 </a>
              </h5>

              <h5 class="text-danger mt-4 fw-bold">
                <a className="text-decoration-none text-danger" href="http://www.timesfreepress.com/news/local/story/2017/may/27/chattanoogcouple-taking-cleft-palate-non-prof/430442/" target="_blank" rel="noopener noreferrer">7. Chattanooga Times Free Press article May 27, 2017 </a>
              </h5>

              <h5 class="text-danger mt-4 fw-bold">
                <a className="text-danger text-decoration-none" href="http://wutc.org/post/against-all-odds-love-without-reason-has-helped-hundreds-children-facing-almost-certain-death#stream/0" target="_blank" rel="noopener noreferrer">8. WUTC interview with Mr. Richard Winham</a>
              </h5>

              {/* <h5 class="text-danger mt-4 fw-bold">
                    <a className="text-decoration-none text-danger" href="http://www.timesfreepress.com/news/community/" target="_blank" rel="noopener noreferrer">6. LWR CELEBRATES 10 YEARS!</a>
                  </h5> */}

              <h5 class="text-danger mt-4 fw-bold">
                <a className="text-danger text-decoration-none" href="http://wutc.org/post/against-all-odds-love-without-reason-has-helped-hundreds-children-facing-almost-certain-death#stream/0" target="_blank" rel="noopener noreferrer">9. WDEF news channel 12, shine fashion show</a>
              </h5>


            </div>
          </div>
        </div>
      </section>



      <Footer />
    </>
  );
}

export { Press };
